import React, {useState, useEffect} from 'react'
import {Button} from '../../globalStyles'
import {
    Nav,
    NavbarContainer,
    NavLogo,
    NavIcon,
    MobMenuIcon, 
    NavMenu,
    NavItem,
    NavLinks,
    NavItemBtn,
    NavBtnLink
} from './Navbar.element'
import {Container} from '../../globalStyles'
import {FaBars, FaTimes} from 'react-icons/fa'
import {IconContext} from 'react-icons/lib'
import { NavLink } from 'react-router-dom'
function Navbar() {
    const [click,setClick] = useState(false);

    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);

    const showButton = () => {
        if(window.innerWidth<=960){
            setButton(false);
        }else{
            setButton(true);
        }
    }
    useEffect( () => {
        showButton();
    },[]);

    window.addEventListener('resize',showButton);

    return (
        <>
        <IconContext.Provider value={{color:'#fff'}}>
            <Nav>
                <NavbarContainer>
                    <NavLogo to="/">
                       <NavIcon/>
                       Rohaan 
                    </NavLogo>
                    <MobMenuIcon onClick={handleClick}>
                        {click ? <FaTimes/> : <FaBars />}
                    </MobMenuIcon>
                    <NavMenu onClick={handleClick} click={click}>
                        <NavItem>
                            <NavLinks to="/">
                                Home
                            </NavLinks>
                        </NavItem>                       
                        <NavItem>
                            <NavLinks to="/education">
                                Education
                            </NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="/projects">
                                Projects
                            </NavLinks>
                        </NavItem>                        
                        <NavItem>
                            <NavLinks to="/contact">
                                Contact
                            </NavLinks>
                        </NavItem>
                        <NavItemBtn>
                            {button ? (
                                <NavBtnLink to="/about-me">
                                    <Button primary>About Me</Button>
                                </NavBtnLink>
                            ):(
                                <NavBtnLink to="/about-me">
                                    <Button fontBig primary>
                                        About Me
                                    </Button>
                                </NavBtnLink>
                            )}
                        </NavItemBtn>
                    </NavMenu>
                </NavbarContainer>
            </Nav>
        </IconContext.Provider>
        </>
    )
}

export default Navbar
